import { CopyToClipboardService } from '@app/shared/services/copy-to-clipboard.service';
import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[clipboardCopy]',
})
export class CopyToClipboardDirective {
  @Input() public clipboardCopy = '';
  @Output() public copyEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() public errorEvent: EventEmitter<Error> = new EventEmitter<Error>();

  /**
   * @param {CopyToClipboardService} clipboard
   */
  constructor(
    private readonly clipboard: CopyToClipboardService,
  ) {}

  @HostListener('click')
  public copyToClipboard(): void {
    this.clipboard.copy(this.clipboardCopy).subscribe(
      (value: string): void => this.copyEvent.emit(value),
      (e): void => this.errorEvent.emit(e),
    );
  }
}
